
import accHttpSvr from 'js/accHttpService';
const catalogHttpService = {};

/**
 * Create http request.
 * @param {*} data any
 * @param {*} ctx any
 * @returns
 */
catalogHttpService.createHttpRequest = async (input, accsessionid) => {
    try {
        const request = {
            method: 'POST',
            url: '/acc/orchestrate',
            withCredentials: true,
            data: input
        };

        return accHttpSvr.createHttpRequest(request, 'catalog', accsessionid);
    } catch (err) {
        console.log('error inside makehttp call', err);
        throw err;
    }
}

export default catalogHttpService;
